export default __webpack_public_path__ + "static/media/SEC0260.34I-18451_-21086_0.80f02c63.jpg";